import { useRef, useState, useEffect } from 'react';

export const useBlockDimensions = () => {
  const blockRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  const updateDimensions = () => {
    setIsScrollable(blockRef.current.scrollHeight > blockRef.current.clientHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  useEffect(() => {
    updateDimensions();
  }, [blockRef.current]);

  return { blockRef, isScrollable };
};
